"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = mergeAddon;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _lodash = _interopRequireDefault(require("lodash.uniqby"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return "symbol" === (0, _typeof2["default"])(key) ? key : key + "";
}

function _toPrimitive(input, hint) {
  if ("object" !== (0, _typeof2["default"])(input) || null === input) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if ("object" !== (0, _typeof2["default"])(res)) return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === hint ? String : Number)(input);
}

function mergeAddon(addonType, addonValue, existingAddons) {
  var existingAddon = existingAddons[addonType] || {};

  if (addonValue === void 0) {
    var removedAddon = existingAddons[addonType],
        rest = (0, _objectWithoutProperties2["default"])(existingAddons, [addonType].map(_toPropertyKey));
    return rest;
  }

  return Array.isArray(addonValue) ? _objectSpread({}, existingAddons, (0, _defineProperty2["default"])({}, addonType, (0, _lodash["default"])([].concat((0, _toConsumableArray2["default"])(existingAddon), (0, _toConsumableArray2["default"])(addonValue)), "value"))) : _objectSpread({}, existingAddons, (0, _defineProperty2["default"])({}, addonType, _objectSpread({}, existingAddon, {
    value: addonValue
  })));
}